import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'next-themes';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Determinar qual tema usar (theme pode ser 'system', então usar systemTheme como fallback)
  const currentTheme = theme === 'system' ? systemTheme : theme;
  const isDarkMode = currentTheme === 'dark';

  return (
    <footer className="border-t border-border bg-muted px-3 md:px-4 py-2 md:py-3">
      <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-0 text-xs md:text-sm text-brand-text-muted">
        <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4 flex-wrap text-center md:text-left">
          <span>© 2026 EscriturAI – Inteligência a Serviço da Palavra Viva</span>
          <span className="hidden md:inline">•</span>
          <div className="flex items-center gap-1">
            <span className="hidden sm:inline">developed by</span>
            {mounted && (
              <>
                <a 
                  href="https://niginex.ai" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity duration-150 flex items-center ml-1"
                >
                  <img 
                    src={isDarkMode 
                      ? "/imgs/logos/niginex-logo-lab-negativo.png?v=2" 
                      : "/imgs/logos/niginex-logo-lab-positivo.png?v=2"
                    }
                    alt="RCA Tecnologia Ltda - niginex LAB" 
                    className="h-4 md:h-5 w-auto"
                  />
                </a>
                <span className="mx-1">&</span>
                <img 
                  src={isDarkMode 
                    ? "/imgs/logos/logo-escriturai-rodape-dark.png" 
                    : "/imgs/logos/logo-escriturai-rodape-light.png"
                  }
                  alt="EscriturIA" 
                  className="h-[0.6rem] md:h-[0.75rem] w-auto"
                />
              </>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 md:gap-4">
          <button
            onClick={() => navigate('/app/support-messages')}
            className="hover:text-brand-accent transition-colors duration-150 cursor-pointer text-xs md:text-sm whitespace-nowrap"
          >
            <span className="hidden sm:inline">Central de Mensagens</span>
            <span className="sm:hidden">Mensagens</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
